import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import IconGiga from '../../assets/image/giga-white.png';
import IconRobotic from '../../assets/image/logo-header.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Form, Input } from 'antd';
import { faPhoneVolume, faPhone } from '@fortawesome/free-solid-svg-icons';

import { useDispatch } from 'react-redux';

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const gigaWhite = 'https://img.gigadigital.vn/image/1663927866720-logoGiga-white.png';

const useViewPort = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
  }, []);
  return { width };
};

const Header = () => {
  const [form] = Form.useForm();
  const [click, setClick] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const viewPort = useViewPort();
  const [maKH, setMaKH] = useState('');
  const isDesktop = viewPort.width >= 768;
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState('');
  useEffect(() => {
    setActiveLink(location.pathname); // Cập nhật activeLink với đường dẫn hiện tại
  }, [location]);
  return (
    <Fragment>
      <div id="top">
        <Container fluid={true} className="search-page container" style={{ width: '70%' }}>
          <div className="position-relative main-header d-flex align-items-center">
            <div className="navbar-header d-flex align-items-center navbar-expand-md me-5">
              <Link to={'/'} className="text-gray fw-bold logo-desktop">
                <img src={IconRobotic} className="position-relative" alt="logo" />
              </Link>

              <button
                className="navbar-toggler"
                onClick={() => setClick(!click)}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
              >
                <i className="fas fa-bars text-gray fw-bold"></i>
              </button>
            </div>
            {isDesktop && (
              <div className="list-navbar-items align-items-center navbar-collapse" id="navbarSupportedContent">
                <ul
                  className="list-unstyled d-flex align-items-center justify-content-evenly mb-0"
                  style={{ width: '100%', justifyContent: 'space-around' }}
                >
                  {/* <li className="me-4">
                    <Link
                      to={'/huong-dan-khac-phuc-loi'}
                      className={`text-center ${activeLink === '/huong-dan-khac-phuc-loi' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Hướng dẫn</b>
                      </div>
                      <div>Khắc phục lỗi</div>
                    </Link>
                  </li> */}
                  <li className="me-4">
                    <Link
                      to={'/huong-dan-su-dung'}
                      className={`text-center ${activeLink === '/huong-dan-su-dung' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Hướng dẫn</b>
                      </div>
                      <div>sử dụng</div>
                    </Link>
                  </li>
                  <li className="me-4">
                    <Link
                      to={'/phu-kien'}
                      className={`text-center ${activeLink === '/phu-kien' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Phụ kiện</b>
                      </div>
                      <div>Thay thế</div>
                    </Link>
                  </li>
                  <li className="me-4">
                    <Link
                      to={'/kich-hoat-bao-hanh'}
                      className={`text-center ${activeLink === '/kich-hoat-bao-hanh' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Kích hoạt</b>
                      </div>
                      <div>Bảo hành</div>
                    </Link>
                  </li>
                  <li className="me-4">
                    <Link
                      to={'/gui-yeu-cau'}
                      className={`text-center ${activeLink === '/gui-yeu-cau' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Yêu cầu</b>
                      </div>
                      <div>Bảo hành</div>
                    </Link>
                  </li>
                  <li className="me-4">
                    <Link
                      to={'/tra-cuu-bao-hanh'}
                      className={`text-center ${activeLink === '/tra-cuu-bao-hanh' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Tiến độ</b>
                      </div>
                      <div>Bảo hành</div>
                    </Link>
                  </li>
                  <li className="me-4">
                    <Link
                      to={'/lap-dat-tai-nha'}
                      className={`text-center ${activeLink === '/lap-dat-tai-nha' ? 'active' : ''}`}
                      style={{ height: '60px', alignContent: 'center', fontSize: '15px' }}
                    >
                      <div>
                        <b>Đăng ký</b>
                      </div>
                      <div>Lắp đặt</div>
                    </Link>
                  </li>
                </ul>
              </div>
            )}
            <ul className="list-unstyled list-data d-flex align-items-center mb-0">
              <li className="hotline text-primary p-2">
                <FontAwesomeIcon icon={faPhoneVolume} className="mx-2" style={{ border: 'none', fontSize: '35px' }} />
                <div>
                  <p className="">Liên hệ hỗ trợ</p> <p style={{ fontSize: '19px', width: '120px' }}>1900 633 870</p>
                </div>
              </li>
            </ul>
          </div>
          {click && (
            <div className="list-navbar-items align-items-center justify-content-between navbar-collapse w-100 shadow-sm" id="navbarSupportedContent">
              <ul className="list-unstyled w-100 mb-0">
                <li className="border-top py-2">
                  <Link
                    onClick={() => setClick(!click)}
                    to={'/huong-dan-su-dung'}
                    className={`fw-bold d-flex align-items-center fs-6 h-100 ${activeLink === '/huong-dan-su-dung' ? 'active' : ''}`}
                  >
                    <b>Hướng dẫn sử dụng</b>
                  </Link>
                </li>
                <li className="border-top py-2">
                  <Link
                    onClick={() => setClick(!click)}
                    to={'/phu-kien'}
                    className={`fw-bold d-flex align-items-center fs-6 h-100 ${activeLink === '/phu-kien' ? 'active' : ''}`}
                  >
                    <b>Phụ kiện thay thế</b>
                  </Link>
                </li>
                <li className="border-top py-2">
                  <Link
                    onClick={() => setClick(!click)}
                    to={'/kich-hoat-bao-hanh'}
                    className={`fw-bold d-flex align-items-center fs-6 h-100 ${activeLink === '/kich-hoat-bao-hanh' ? 'active' : ''}`}
                  >
                    <b>Kích hoạt bảo hành</b>
                  </Link>
                </li>
                <li className="border-top py-2">
                  <Link
                    onClick={() => setClick(!click)}
                    to={'/gui-yeu-cau'}
                    className={`fw-bold d-flex align-items-center fs-6 h-100 ${activeLink === '/gui-yeu-cau' ? 'active' : ''}`}
                  >
                    <b>Yêu cầu bảo hành</b>
                  </Link>
                </li>
                <li className="border-top py-2">
                  <Link
                    onClick={() => setClick(!click)}
                    to={'/tra-cuu-bao-hanh'}
                    className={`fw-bold d-flex align-items-center fs-6 h-100 ${activeLink === '/tra-cuu-bao-hanh' ? 'active' : ''}`}
                  >
                    <b>Tiến độ bảo hành</b>
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </Container>
      </div>
    </Fragment>
  );
};

export default Header;
